import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ImSpinner8 } from 'react-icons/im';
import { useDispatch, useSelector } from 'react-redux';

import { exchangeContact } from '../../redux/features/profile/profileSlice';
import successGIF from '../../assets/success.gif';

const AfricaNewsAgencyModal = ({ info, tagId }) => {
  // React Hook Form methods
  const { register, handleSubmit, formState, reset } = useForm();
  const { errors } = formState;

  // index local state
  const [index, setIndex] = useState(0);

  // dispatch
  const dispatch = useDispatch();

  // redux
  const { isExchanging, isExchanged } = useSelector(state => state.profile);

  // handle Note submission
  const onSubmitNote = ({ names, phone_number, email }) => {
    const exchangeData = {
      user_tag_id: tagId,
      names,
      phone_number,
      email,
    };
    dispatch(exchangeContact(exchangeData));
    reset();
  };

  // handle order yours
  const handleOrderYours = () => {
    window.location.href = 'https://bizcotap.com/products';
  };

  useEffect(() => {
    if (isExchanged) {
      setIndex(1);
    }
  }, [isExchanged]);

  return (
    <div className='w-full mb-2'>
      <div className='bg-gray-200 h-[4px] w-[60px] mx-auto rounded-full my-2' />
      {index === 0 && (
        <div className='px-5'>
          <h2 className='modal-title exchange-sheet-title'>Remind {info?.fname} Who you are</h2>
          <div className='mt-12'>
            <form onSubmit={handleSubmit(onSubmitNote)}>
              <div className='relative z-0 w-full mb-6'>
                <input
                  type='text'
                  name='names'
                  placeholder='Enter your Name'
                  className='block w-full px-8 floating-input'
                  {...register('names', { required: true })}
                />
                <label className='floating-label font-[Lemonmilk-Regular]'>Name</label>
                <span className='text-red-600 text-[13px]'>
                  {errors.names?.type === 'required' && 'Name is required'}
                </span>
              </div>
              <div className='relative z-0 w-full mb-6'>
                <input
                  type='text'
                  name='phone_number'
                  placeholder='Enter your Phone Number'
                  className='block w-full px-8 floating-input'
                  {...register('phone_number', { required: true })}
                />
                <label className='floating-label font-[Lemonmilk-Regular]'>Phone</label>
                <span className='text-sm text-red-600'>
                  {errors.phone_number?.type === 'required' && 'Phone is required'}
                </span>
              </div>
              <div className='relative z-0 w-full mb-6'>
                <input
                  type='text'
                  name='email'
                  className='block w-full px-8 floating-input'
                  placeholder='Enter your e-mail'
                  {...register('email', { required: true })}
                />
                <label className='floating-label font-[Lemonmilk-Regular]'>Email</label>
                <span className='text-sm text-red-600'>{errors.email?.type === 'required' && 'Email is required'}</span>
              </div>

              <button
                id='button'
                type='submit'
                className='w-full px-6 py-3 mb-3 mt-3 text-lg text-white transition-all duration-150 ease-linear rounded-lg shadow outline-none bg-[#0c4d8d] focus:outline-none font-[Lemonmilk-Regular]'
              >
                {!isExchanging ? (
                  'Exchange'
                ) : (
                  <span>
                    <ImSpinner8 size={20} className='animate-spin text-white inline-block mr-3' />
                    Exchanging
                  </span>
                )}
              </button>
            </form>
            <div className='my-3 text-[12px] font-display font-semibold text-gray-700 text-center font-[Lemonmilk-Regular]'>
              Bizcotap Does not Share or Sell your Data
            </div>
          </div>
        </div>
      )}

      {index === 1 && (
        <div className='px-5'>
          <div className='pt-3'>
            <img className='w-[150px] mx-auto' src={successGIF} alt='success gif' />
          </div>
          <p className='text-center py-4'>
            Successfully Exchanged your <br /> contacts with <span className='font-bold'>{info?.fname}</span>
          </p>
          <div className='my-4 p-4'>
            <button className='w-full py-[8px] border-[#0c4d8d] border-[2px] text-[15px]' onClick={handleOrderYours}>
              Order Yours Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AfricaNewsAgencyModal;
